export default __webpack_public_path__ + "static/media/logo_header.6ca2872e.png";